import * as React from "react";
import { forwardRef } from "react";
const SvgInteractive = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.3388 12.7743L10.416 18L5 6L18 10.9994L12.3388 12.7743ZM12.3388 12.7743L17.2569 17.3141", stroke: "currentcolor", strokeWidth: 2, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgInteractive);
export default ForwardRef;
